import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from 'prop-types';
import { Input } from '../Input/Input';
/**
 * Standard email input component composing the
 * standard NerdWallet input component.
 *
 * There are some props that we don't allow the consumers
 * to override (like type) on the underlying Input component.
 *
 * InputEmail has an opinionated design, and some of those props
 * are not surfaced in InputEmail.propTypes.
 */

export var InputEmail = function InputEmail(_ref) {
  var label = _ref.label,
      otherProps = _objectWithoutProperties(_ref, ["label"]);

  return /*#__PURE__*/React.createElement(Input, _extends({
    label: label
  }, otherProps, {
    type: "email"
  }));
};
InputEmail.propTypes = {
  /**
   * The default label associated with
   * the input field. Should always be supplied
   * to meet accessibility best practices.
   */
  label: PropTypes.string
};
InputEmail.defaultProps = {
  label: 'Email address'
};